import {
  isTasksEnabled,
  isManualPatientCreationRestricted,
} from "@/services/config";
import store from "@/store";

const canCreatePatient = () => {
  if (!isManualPatientCreationRestricted) return true;
  return (
    !store.getters.isAdmin &&
    !store.getters.isDoctor &&
    !store.getters.isAssistant &&
    !store.getters.isManager
  );
};

const patientRoutes = [
  {
    path: "/patient",
    component: () =>
      import(/* webpackChunkName: "patient" */ "../layouts/PatientLayout.vue"),
    children: [
      {
        path: "/patient",
        name: "patient",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientList.vue"
          ),
      },
      {
        path: "/patient/create",
        name: "create-patient",
        meta: {
          condition: canCreatePatient,
          redirectTo: { name: "patient" },
        },
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientDetail.vue"
          ),
      },
      {
        path: "/patient/:id",
        name: "update-patient",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientDetail.vue"
          ),
      },
      {
        path: "/patient/:id/treatment",
        name: "assign-treatment-patient",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientTreatmentDetail.vue"
          ),
      },
      {
        path: "/patient/:id/dashboard",
        name: "patient-dashboard",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/dashboard/PatientDashboard.vue"
          ),
      },
      // This is exactly the same as the previous route, because the screens supports both paths with id or without id
      {
        path: "/patient/me",
        name: "patient-me",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/dashboard/PatientDashboard.vue"
          ),
      },
      {
        path: "/patient/:id/tasks",
        name: "patient-tasks",
        meta: { enabled: isTasksEnabled },
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientTasks.vue"
          ),
        children: [
          {
            path: ":taskType/create",
            name: "create-patient-task",
            component: () =>
              import(
                /* webpackChunkName: "patient" */ "../components/task/TaskDetail.vue"
              ),
          },

          {
            path: ":taskType/:taskID",
            name: "update-patient-task",
            component: () =>
              import(
                /* webpackChunkName: "patient" */ "../components/task/TaskDetail.vue"
              ),
          },
        ],
      },
      {
        path: "/patient/:id/sales",
        name: "sales-list",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/dashboard/sales/SalesList.vue"
          ),
      },
      {
        path: "/print",
        name: "event-print",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/printing/FormPrint.vue"
          ),
      },
    ],
  },
];

export default patientRoutes;
